const paths = {
  main: '/signup',
  thank: '/signup/thank',
  confirm: '/signup/confirm',
  resendConfirm: '/signup/resend-confirm',
};

export default paths;
